export enum NextGenRight {
    CREATE = "create",
    UPDATE = "update",
    VIEW = "view",
    DELETE = "delete",
    ANY = "any"
}

export enum OutputType {
    HIDE = 'hide',
    DISABLE = 'disable'
}

export enum Module {
    FACILITY = 1,
    SYSTEM_SETTINGS  = 2
}

export enum UserFunction {
    COUNTRY = 10000000,
    ZIP = 2,
    Billing_Types = 8
}

export enum CheckType{ 
    MODULE_LEVEL = 1,
    USER_FUNCTION_LEVEL = 2
}

export class NextGenPermission {
    Rights: any[];
    UIBehaviour: OutputType;
    Module:Module;
    UserFunction:UserFunction;
    CheckType?:CheckType;

    constructor(rights,uiBehaviour:OutputType,module:Module,userFunction:UserFunction, checkType?: CheckType) {
      this.Rights = rights;
      this.UIBehaviour = uiBehaviour;
      this.Module = module;
      this.UserFunction = userFunction;
      this.CheckType = checkType;
    }

}

